import './create-user-drawer.scss'

import { Button, Divider, Drawer, Typography } from 'antd'
import React, { useState } from 'react'
import { Column, Row } from 'react-display-flex'

import { drawerAndModalWidth } from '../../../util/guideline'
import { User } from '../models'
import { UserTenants } from '../TenantsAccess'
import { CreateUser } from './CreateUser'

export const CreateUserDrawer = ({ isVisible, onSuccess }) => {
  const [createdUser, setCreatedUser] = useState(null)

  const onCreateUserSuccess = (user: User) => setCreatedUser(user as any)

  const onCloseDrawer = () => {
    setCreatedUser(null)
    onSuccess()
  }

  return (
    <Drawer title="Create user" placement="right" open={isVisible} onClose={onCloseDrawer} width={drawerAndModalWidth}>
      {createdUser ? (
        <>
          <Typography.Title level={3}>User Information</Typography.Title>
          <Row className="description">
            <dl>
              <dt>Name</dt>
              <dd>
                {createdUser.firstName} {createdUser.surname}
              </dd>
            </dl>
            <dl>
              <dt>Email</dt>
              <dd>{createdUser.email}</dd>
            </dl>
          </Row>
          <Divider />
          <UserTenants user={createdUser} />
          <Column>
            <Button type="primary" onClick={onCloseDrawer}>
              Done
            </Button>
          </Column>
        </>
      ) : (
        <CreateUser onSuccess={onCreateUserSuccess} />
      )}
    </Drawer>
  )
}
